import { nearbyPopularVenues } from 'redux/saga/entities/bound';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { call, put, takeEvery } from 'redux-saga/effects';
import { isAbsent, isEmpty } from 'helpers/verify';

const MAX_VENUES = 20;
const MIN_VENUES = 8;
const MIN_RATING = 4.0;
const RADIUS_ATTEMPTS = [5, 10, 30];

const LOAD_VENUE_DATA = 'cmsPage/modules/VisitableVenues/LOAD_VENUE_DATA';

export const loadVenues = location => ({ type: LOAD_VENUE_DATA, ...location });

export const nearbyVenuesKey = location => location && `venues-near-${location.lat}-${location.lon}`;

export function filterValidVenues(venues) {
  try {
    return venues.filter(
      ({
        ratings: {
          count: { total },
          mean,
        },
      }) => mean >= MIN_RATING || total === 0
    );
  } catch (error) {
    return [];
  }
}

export function* getNearbyPopularVenues(client, location, radii) {
  if (isAbsent(radii)) {
    radii = RADIUS_ATTEMPTS;
  }

  const key = nearbyVenuesKey(location);
  const [radius, ...nextRadii] = radii;

  if (isAbsent(radius)) {
    return;
  }

  const { venues } = yield call(
    fetchEntityIfNeeded,
    nearbyPopularVenues,
    [
      client,
      0,
      {
        lat: location.lat,
        lon: location.lon,
        page_size: MAX_VENUES,
        page: 0,
        radius,
      },
    ],
    { key }
  );

  const validVenueCount = filterValidVenues(venues).length;
  if (validVenueCount < MIN_VENUES && !isEmpty(nextRadii)) {
    yield put(nearbyPopularVenues.resetAction({ key }));
    yield call(getNearbyPopularVenues, client, location, nextRadii);
  }
}

export function* doLoadVenues(client, { lat, lon }) {
  try {
    if ([lat, lon].some(isAbsent)) {
      return;
    }

    yield call(getNearbyPopularVenues, client, { lat, lon });
  } catch (error) {
    /* noop */
  }
}

export function* watchSaga(client) {
  yield takeEvery(loadVenues().type, doLoadVenues, client);
}
